module.exports = __webpack_public_path__ + "media/images/qr/audiobook-qr-colour-520cfd968fce7a8b45d29d127adaeeed.svg";